//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/js/utils';
export default {
  name: 'UserAccessPermission',
  props: {
    permissions: {
      type: Array,
      require: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fields: [{
        key: 'capability_name',
        label: 'Name',
        class: 'w-50',
        sortable: true
      }, {
        key: 'group_name',
        label: 'Grupo',
        class: 'text-center w-50',
        sortable: true
      }],
      filter: '',
      currentViewPage: 1,
      perPage: 7
    };
  },
  methods: {
    addRecord: function addRecord() {
      this.items.push(this.record);
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalId);
    },
    handleSubmit: function handleSubmit() {
      this.record['creation_date'] = new Date().toJSON().slice(0, 10).split('-').reverse().join('/');
      this.record['updated_user'] = window.userInfo.email;
      this.record['date_updated'] = new Date().toJSON().slice(0, 10).split('-').reverse().join('/');
      this.record['active'] = true;
      this.items.push(this.record);
      this.$bvModal.hide(this.modalId);
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.recordSelected = data.index;
        this.record = utils.cloneJSON(data.item);
        this.record_original = utils.cloneJSON(data.item);
      } else {
        this.record = {};
      }
      this.mode = mode;
      this.$root.$emit('bv::show::modal', this.modalId, '#btnShow');
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.processing = false;
      this.busy = true;
    },
    onCancelDelete: function onCancelDelete() {
      this.busy = false;
    },
    onConfirmDelete: function onConfirmDelete() {
      var _this = this;
      this.processing = true;
      this.overlay_message = 'Deleting';
      setTimeout(function () {
        _this.items = _this.items.filter(function (item) {
          return item.user_dp !== _this.record.user_dp;
        });
        _this.busy = _this.processing = false;
      }, 2000);
    }
  }
};